import { ESaleType } from '../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../packages/JsonQuery';

export const NEWBUILDING_SALE_TYPES: NonEmptyArray<ESaleType> = [
  ESaleType.F3,
  ESaleType.GSKContract,
  ESaleType.Reassignment,
  ESaleType.PreliminaryContract,
  ESaleType.InvestmentContract,
];

export const FLAT_OLD_SALE_TYPES: NonEmptyArray<ESaleType> = [ESaleType.Free, ESaleType.Alternative];
